import IconButton from "../../../../common/IconButton";
import {faSignature} from "@fortawesome/free-solid-svg-icons";
import {Spinner} from "react-bootstrap";
import SelectCertificateWrapperComponent from "../../components/SelectCertificateWrapperComponent";
import React, {useEffect, useState} from "react";
import {selectLang, Translate} from "../../../../../app/store/reducers/main/mainReducer";
import {useSelector} from "react-redux";
import {selectCurrentCertificate} from "../../../../../app/store/reducers/eimzo/eimzoReducer";
import EventBus from "../../../../../app/eventbus/EventBus";
import {ROAMING_INVOICE_BULK_ACTION_FINISHED, ROAMING_INVOICE_BULK_ACTION_STARTED} from "../../../../../app/eventbus/roaming/roamingInvoiceEvents";
import {loadInvoicesAsync, sendAsync} from "../../../../../app/store/reducers/roaming/roamingInvoiceReducer";
import {DRAFT} from "../../../../../enum/RoamingInvoiceWrapper";
import {ACTION_PROGRESS_BAR_CLOSED} from "../../../../../app/eventbus/actionProgressBarEvents";

const RoamingInvoiceDraftSendAll = ({filters, predefinedFilters, setCount, handleShowProgressBar, updateActionResult, ...props}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const activeCertificate = useSelector(selectCurrentCertificate);

    // button loader
    const [loading, setLoading] = useState(false);

    const onSendTriggered = async () => {
        if (!window.confirm(t(lang, 'roaming.invoice.send_button_all_confirmation_text')))
            return;

        let stop = false
        const onActionProgressBarCloseHandler = EventBus.on(ACTION_PROGRESS_BAR_CLOSED, () => {
            stop = true
        })

        handleShowProgressBar();
        EventBus.dispatch(ROAMING_INVOICE_BULK_ACTION_STARTED);

        // load invoices
        let invoices = []
        let page = 1
        let limit = 1000;
        while (true) {
            const finalFilters = {...filters, ...predefinedFilters, limit: limit, page: page}
            const data = await loadInvoicesAsync(DRAFT, finalFilters)
            if (data.length <= 0)
                break

            for (let i = 0; i < data.length; i++) {
                invoices.push(data[i])
            }
            page++
        }

        setCount(invoices.length);

        const taskSize = 10;
        const tasks = []

        const signer = async invoice => {
            if (stop) {
                return
            }
            try {
                await sendAsync(activeCertificate, lang, invoice.content);
                updateActionResult({
                    number: invoice.info.number,
                    date: invoice.info.date,
                    contractor: {
                        name: invoice.customer.name,
                        inn: invoice.customer.inn
                    }
                });
            } catch (error) {
                updateActionResult({
                    number: invoice.info.number,
                    date: invoice.info.date,
                    contractor: {
                        name: invoice.customer.name,
                        inn: invoice.customer.inn
                    },
                    error: error?.message
                })
            }
        }

        for (let i = 0; i < invoices.length; i++) {
            tasks.push(signer(invoices[i]))

            if (tasks.length >= taskSize) {
                await Promise.all(tasks)
                tasks.splice(0, tasks.length)
            }
        }

        if (tasks.length > 0) {
            await Promise.all(tasks)
            tasks.splice(0, tasks.length)
        }

        EventBus.remove(ACTION_PROGRESS_BAR_CLOSED, onActionProgressBarCloseHandler)
        EventBus.dispatch(ROAMING_INVOICE_BULK_ACTION_FINISHED);
    };

    return <SelectCertificateWrapperComponent submitButton={
        <IconButton icon={faSignature}
                    variant="falcon-primary"
                    id="DraftSendAll"
                    disabled={loading}
                    onClick={onSendTriggered}
                    className="m-1"
                    {...props}
        >
            {loading && <Spinner size="sm" className='align-middle me-2' animation='border' role='switch'/>}
            {t(lang, "roaming.invoice.send_button_all")}
        </IconButton>
    } openDialogButtonText={t(lang, "roaming.invoice.send_button_all")}
    />
};

export default RoamingInvoiceDraftSendAll;

